import { tvSectionList, sectionCategorySorts, DEFAULT_SECTION_CODE } from '../constants';
import { SECTION_LIST_PAGE_LIMIT } from '../constants/number';

export const getSectionDataApiUrl = (offset = 0, sort = '', section = DEFAULT_SECTION_CODE, category = '', limit = SECTION_LIST_PAGE_LIMIT) => {
  //console.log('getSectionDataApiUrl - section :>> ', section);
  const isAllData = !category;
  let currentSectionDataIndex = tvSectionList.findIndex(x => x.code === section);
  if (currentSectionDataIndex < 0) {
    currentSectionDataIndex = 0;
  }
  const currentSectionData = tvSectionList[currentSectionDataIndex];

  const sectionCategorySort = sectionCategorySorts[currentSectionData.sortType];
  const tvSectionDataApiUrl = new URL(process.env.NEXT_PUBLIC_API_RECOMMEND_SECTION_TV);
  const urlSubPath = isAllData ? currentSectionData.api.subPath.all : currentSectionData.api.subPath.category;
  tvSectionDataApiUrl.pathname += urlSubPath;

  let sortSearchParam;
  if (sectionCategorySort && Array.isArray(sectionCategorySort.searchParamList) && sectionCategorySort.searchParamList.length > 0) {
    if (sort) {
      sortSearchParam = sectionCategorySort.searchParamList.find(x => x.code === sort);
    } else {
      sortSearchParam = sectionCategorySort.searchParamList[0];
    }
  }

  if (currentSectionData.api.pgmSct) {
    tvSectionDataApiUrl.searchParams.set('pgm_sct', currentSectionData.api.pgmSct);
  }

  if (category) {
    try {
      const currentCategory = currentSectionData.category.find(x => x.code === category);
      const relatedCategory = currentCategory.relatedCategory;
      const pgmSct = currentCategory.pgmSct || '';

      if (pgmSct) {
        tvSectionDataApiUrl.searchParams.set('pgm_sct', pgmSct);
      }
      relatedCategory.forEach(themaCode => {
        tvSectionDataApiUrl.searchParams.append('thema_cd', themaCode);
      });
    } catch (error) {
      //console.log('tvUtil category error : ' + error);
    }
  }

  if (!sortSearchParam?.isSkipParam && sortSearchParam?.code) {
    tvSectionDataApiUrl.searchParams.set(sectionCategorySort.searchParamKey, sortSearchParam.code);
  }
  tvSectionDataApiUrl.searchParams.set('offset', offset);
  tvSectionDataApiUrl.searchParams.set('limit', limit);

  return tvSectionDataApiUrl;
};
